module.exports = __webpack_public_path__ + "img/luna nueva.a1b6317a.png";